<template>
	<header-block :title="this.document ? document.documentType : 'Document'" :del="true" @delete="deleteDocument" :edit="true" @edit="onEdit"></header-block>
	<CustomerLoadWait :customer="document" />
	<transition>
		<div v-if="document && wellData.length > 0">
			<WellPanel 
				:title="document.documentName" 
				:subTitle="document.documentType"
				:avatarLetter="document.documentType.charAt(0)"
				:data="wellData"
				:editMode="editMode"
				:supplement="document.sysoDocumentType && document.sysoDocumentType.aiopSection == 'insurance' ? (document.renewalDate ? ('Renews ' + document.renewalDateString) : null) : null"
				@save="(title) => { onWellSaved(title); }"
			/>
			<div style="height: 50px;"></div>
		</div>
	</transition>
	
	<DrawerPanel v-if="document && !editMode" :bottom="_peekingDrawerBottom_NoMenu()" :closedHeight="_closedDrawerHeightNoMenu()" openHeight="250px" title="Uploaded Document" backgroundColor="white" openBackgroundColor="white">
		<div class="docsPanel">
			<a :href="document.url">
				<v-row>
					<v-col cols="2" class="docIconCol"><v-icon class="docIcon" icon="mdi-file-document-outline"></v-icon></v-col>
					<v-col class="docCol">{{ document.name }}<br/><span>{{ document.createDateTimeString }}</span></v-col>
					<v-col cols="1" class="arrowCol"><img class="arrow" src="../assets/arrow-right.png" /></v-col>
				</v-row>
			</a>
		</div>
	</DrawerPanel>
	<!-- <ChatMgButton v-if="document && !editMode" :hover="true" :icon="require('@/assets/ai.png')" :prompt="'Summarise my document with te ID: ' + document.id" bottom="10%" /> -->
</template>

<script>
import Helpers from '../mixins/Helpers';
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import WellPanel from './elements/WellPanel.vue';

export default {
	mixins: [Services, Helpers],
	components: {CustomerLoadWait, HeaderBlock, WellPanel, DrawerPanel},
	data() {
		return {
			policyId: null,
			document:null,
			wellData: [],
			editMode: false,
		}
	},
	methods: {
		onLoad: async function() {
			this.documentId = this.$route.params.id;
			this._getCustomer();
			this._getDocument(this.documentId, (doc) => {
				this.document = doc;
				this.wellData = doc.wellData.DataArray.map((item, index) => {
					return {
						order: index + 1,
						label: item.Title,
						value: item.Value
					};
				});
				
			});
		},

		deleteDocument() {
			this._deleteDocument(this.documentId, () => {
				// Remove the document from the list after successful deletion
				this._clearDocuments();
				this.$router.back();
			});
		},

		onEdit() {
			console.log('Setting edit mode');
			this.editMode = true;
		},
		onWellSaved(docName) {
			this.document.documentName = docName;
			this.document.wellData.DataArray = this.wellData.map(item => ({
				Title: item.label,
				Value: item.value
			}));
			this.document.processedMeta = JSON.stringify(this.document.wellData);
			this._updateDocument(this.document, () => {
				this.editMode = false;
			});
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.docsPanel {
	padding-right: 20px;
}

.docIconCol {
	padding-top: 17px;
	font-size: 18px;
}

.docIcon {
	c--olor: var(--grey-text);
}

.docCol {
	font-size: 14px;
	c--olor: var(--grey-text);
}

.arrowCol {
	padding-top: 22px;
}

.arrow {
	width: 18px;
	
}

</style>
